var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgListPan = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.5126 2.57187C14.1969 1.8875 15.3032 1.8875 15.9876 2.57187L17.4282 4.0125C18.1126 4.69688 18.1126 5.80313 17.4282 6.4875L15.2094 8.70625L14.8813 9.03125L13.6126 13.6906C13.4626 14.2469 13.0469 14.6906 12.5032 14.8813L4.25007 17.7812C3.67194 17.9844 3.02819 17.8375 2.59694 17.4062C2.16569 16.975 2.01569 16.3281 2.21882 15.75L5.11882 7.49687C5.30944 6.95312 5.75319 6.54062 6.30944 6.3875L10.9688 5.11875L11.2938 4.79375L13.5126 2.575V2.57187ZM11.2782 6.5875L6.70319 7.83437C6.62507 7.85625 6.55944 7.91563 6.53444 7.99375L3.95319 15.3406L7.14694 12.1469C7.05319 11.95 7.00007 11.7312 7.00007 11.5C7.00007 10.6719 7.67194 10 8.50007 10C9.32819 10 10.0001 10.6719 10.0001 11.5C10.0001 12.3281 9.32819 13 8.50007 13C8.26882 13 8.05007 12.9469 7.85319 12.8531L4.65944 16.0469L12.0063 13.4656C12.0844 13.4375 12.1438 13.375 12.1657 13.2969L13.4126 8.72188L11.2782 6.5875Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgListPan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "4fe6d2f355cc92676bb2319ee3367a43.svg";